import CommentsList from '../../components/comments/list.vue'
import { createApp } from 'vue'

$.onmount('[data-vue=comments-list]', function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)
  const app = createApp(CommentsList, { initialData })
  app.mount(this)
})
